<template lang="pug">
  aside.Paragraph.Paragraph-margin.ParagraphDYKT
    .ParagraphDYKT_timber
      .ParagraphDYKT_timberWrapper
        p.ParagraphDYKT_title(v-if="title") {{title}}
        p.ParagraphDYKT_desc(v-if="description") {{description}}
</template>

<script>

export default {
  props: ['item'],
  data () {
    return {}
  },
  computed: {
    title () {
      return this.item.didYouKnowThat.title
    },
    description () {
      return this.item.didYouKnowThat.description
    }
  }
}

</script>

<style lang="stylus" scoped>

// TODO : faire en sorte qu'il float ?

.ParagraphDYKT
  max-width 1100px

  @media $mq_s_only
    padding 0 20px

  &_timber
    background-color $black
    position: relative
    padding 10px
    width 340px
    color $beige
    text-align: center

    p
      font-size 18px
      font-weight: 400


  &_timberWrapper
    box-sizing border-box
    padding 35px 20px
    min-height: 310px
    border 1px solid $beige
    display: flex
    flex-direction: column
    align-items: stretch
    justify-content: center

  &_title
    line-height: 35px
    padding-bottom 15px
    position: relative
    margin-bottom 15px
    text-transform: uppercase

    &::before
      position: absolute
      content ''
      display: block
      bottom 0
      left 50%
      transform translate(-50%,0)
      width 50px
      height 2px
      background-color currentColor

  &_desc
    line-height: 40px

</style>
